var exports = {
  "k": "xe533113f--e100c5--container",
  "m": "xe533113f--e100c5--separator",
};

module.exports = exports;
